import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setPracticeAssignmentsList,
    setloading,
    seterror,
    setPagination,
    resetPracticeAssignmentsList,
} from "../reducers/getPracticeAssignmentsReducer";

const getPracticeAssignments = (id: any, token: any, courseType:any) => async (
    dispatch: Dispatch
) => {
    dispatch(setloading(true));
    try {
        const endpoint =
            courseType === 1
                ? `/assignments/get-practice-assignments-by-assignment/${id}/`
                : `competitive/assignments/get-practice-assignments-by-assignment/${id}/`;

        const result = await api.get(endpoint, { 
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Token ${token}`,
            },
        });

        if (result) {
            dispatch(setloading(false));
            if (result.data?.status === 200) {
                dispatch(setPracticeAssignmentsList(result.data.data));
                dispatch(setPagination(result.data));
            } else {
                dispatch(seterror(result.data?.message ?? "Something Went Wrong!"));
            }
        }
    } catch (error: any) {
    }
};

export { getPracticeAssignments, resetPracticeAssignmentsList };
